const $ = jQuery.noConflict();

'use strict';
const PrintPage = {

	$domPrintBtn: $('.js-print-btn'),

	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {
		this.$domPrintBtn.on('click', function() {
			print();
		});
	},
};

export default PrintPage;
